import axios from 'axios';

let prefix = "/gacha-probability-rate"

const GachaProbabilityRateApi = {
	listGachaProbabilityRate(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	bulkCreateGachaProbabilityRate(payload) {
		return axios.post(prefix + "/bulk-create", payload)
	},
	bulkUpdateGachaProbabilityRate(payload) {
		return axios.post(prefix + "/bulk-update", payload)
	},
	archiveGachaProbabilityRate(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createGachaProbabilityRate(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateGachaProbabilityRate(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default GachaProbabilityRateApi;